import { defineMessages } from 'react-intl';

export default defineMessages({
  userType: {
    id: 'adminConsole.userType',
    defaultMessage: 'Utente Azimut',
    description: 'User type',
  },
});
